import type * as React from 'react'

// A React portal re-dispatches through the COMPONENT tree, so an overlay mounted from a list row's action menu
// hands every click inside it to the row's enclosing <Link> and navigates away mid-flow; base-ui's own
// outside-press listeners are native and document-level, so dismissal is untouched by this.
export function stopReactBubble(
  onClick?: React.MouseEventHandler<HTMLDivElement>,
): React.MouseEventHandler<HTMLDivElement> {
  return (event) => {
    event.stopPropagation()
    onClick?.(event)
  }
}
